import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner-overlay" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "User Details", -1)
const _hoisted_3 = { class: "form-body" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name", -1)
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name", -1)
const _hoisted_9 = { class: "form-input" }
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, " Organization (Optional) ", -1)
const _hoisted_12 = { class: "form-input" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "form-controls" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Submit")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              id: "firstName",
              maxlength: "80",
              required: "",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userModel.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.userModel.firstName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "lastName",
              maxlength: "80",
              required: "",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userModel.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.userModel.lastName]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              id: "organization",
              maxlength: "120",
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userModel.organization) = $event))
            }, null, 512), [
              [_vModelText, _ctx.userModel.organization]
            ])
          ])
        ])
      ]),
      _hoisted_13
    ], 32)
  ]))
}